<script setup lang="ts">
import { storeToRefs } from "pinia";
import { watch } from "vue";
import { useRoute } from "vue-router";
import { useKeepAliveCacheStore } from "@/stores";

const route = useRoute();

const getCacheKey = (r = route) => {
	const matched = r.matched;

	return matched[0].name as string;
};

const keepAliveCache = useKeepAliveCacheStore();
const { cacheList, MAX_CACHE_SIZE } = storeToRefs(keepAliveCache);

// 监听路由变化，动态维护缓存列表
watch(
	() => route.fullPath,
	() => {
		const matched = route.matched;

		matched.forEach((item) => {
			if (item.name && item.meta?.keepAlive) {
				keepAliveCache.addCache(item.name as string);
			}
		});
	},
	{ immediate: true }
);
</script>

<template>
	<RouterView v-slot="{ Component, route }">
		<KeepAlive :include="cacheList" :max="MAX_CACHE_SIZE">
			<component :is="Component" :key="getCacheKey(route)" />
		</KeepAlive>
	</RouterView>
</template>
